import { useState, useCallback } from "react";
import { likePost, unlikePost } from "../APIs/likeApi";

const useLike = (postId, initialLiked = false, initialCount = 0) => {
  const [liked, setLiked] = useState(initialLiked);
  const [likeCount, setLikeCount] = useState(initialCount);
  const [loading, setLoading] = useState(false);

  const handleLike = useCallback(async () => {
    if (loading) return;
    
    // Optimistic update — pehle UI update karo
    const newLiked = !liked;
    setLiked(newLiked);
    setLikeCount((prev) => newLiked ? prev + 1 : prev - 1);

    try {
      setLoading(true);
      if (newLiked) {
        await likePost(postId);
      } else {
        await unlikePost(postId);
      }
    } catch (error) {
      // Error pe rollback karo
      console.error("Like action failed:", error);
      setLiked(!newLiked);
      setLikeCount((prev) => newLiked ? prev - 1 : prev + 1);
    } finally {
      setLoading(false);
    }
  }, [postId, liked, loading]);

  return { liked, likeCount, loading, handleLike };
};

export default useLike;